<div class="space-y-3">
  @for(control of formArray.controls; track $index) {
  <div class="flex items-center gap-2 animate-fade-in">
    <div class="flex-grow">
      <app-key-value-input
        [formControl]="$any(control)"
        [keys]="keys()"
        [allowOther]="allowOther()"
      ></app-key-value-input>
    </div>
    @if (formArray.length > 1) {
    <app-button
      type="button"
      (click)="removeItem($index)"
      variant="ghost"
      size="sm"
      shape="circle"
      icon="XCircle"
      [iconOnly]="true"
      aria-label="Remove item"
    >
      <lucide-icon name="XCircle" size="16"></lucide-icon>
    </app-button>
    }
  </div>
  }
</div>
<app-button
  type="button"
  (click)="addItem()"
  variant="outline"
  prefixIcon="Plus"
  class="w-full mt-1"
>
  {{ addButtonLabel() }}
</app-button>
